import LogoHorizontalSvg from 'src/assets/images/logo-horizontal.svg';
import styled from 'styled-components';

export const LogoHorizontal = styled(LogoHorizontalSvg)`
  height: 2.0625rem;
`;
